var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo2 = function SvgLogo2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.84 38.58",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "haardbeat-logo2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M89,24.56l.35.6h.53l-1.57-2.48h-.51l-1.53,2.48h.47l.35-.6Zm-1.71-.33L88,23l.75,1.26Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.29,
    y: 22.47,
    width: 0.46,
    height: 2.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.72 24.95 80.72 22.47 81.19 22.47 81.19 24.62 83.33 24.62 83.33 24.95 80.72 24.95",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.33,22.68v2.15h2V22.68h.47v1.91a.68.68,0,0,1-.13.46.76.76,0,0,1-.51.11H77.51a.76.76,0,0,1-.51-.11.63.63,0,0,1-.15-.46V22.68Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.65,25.16a.79.79,0,0,1-.53-.11.63.63,0,0,1-.13-.46v-.51l.47-.09v.84H75V22.68h.47v1.91a.63.63,0,0,1-.14.46c-.08.09-.26.11-.5.11Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.78 24.95 67.78 23.87 66.34 22.47 66.94 22.47 68.02 23.58 69.08 22.47 69.66 22.47 68.24 23.87 68.24 24.95 67.78 24.95",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.41,25.16a1.09,1.09,0,0,0,.58-.11.42.42,0,0,0,.2-.37v-.32a.39.39,0,0,0-.14-.33.56.56,0,0,0-.35-.15.8.8,0,0,0,.35-.14.35.35,0,0,0,.11-.28v-.29a.46.46,0,0,0-.13-.38.67.67,0,0,0-.46-.11H63.31v2.48Zm0-.33c.13,0,.2,0,.24-.07a.26.26,0,0,0,.07-.22v-.22a.26.26,0,0,0-.07-.22c0-.05-.11-.07-.24-.07H63.77v.8ZM63.77,23.7V23h1.62a.58.58,0,0,1,.24,0,.28.28,0,0,1,.05.17v.25a.25.25,0,0,1-.07.18.44.44,0,0,1-.22,0Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.78 13.39 90.78 18.99 89.72 18.99 89.72 13.39 86.75 13.39 86.75 12.5 93.77 12.5 93.77 13.39 90.78 13.39",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.64,17.61l.85,1.59h1.19l-3.61-6.49H82.92L79.37,19.2h1.07l.84-1.59Zm-3.92-.82,1.75-3.33,1.75,3.33Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.19 18.99 71.19 12.5 77.44 12.5 77.44 13.39 72.28 13.39 72.28 15.18 75.42 15.18 75.42 16.05 72.28 16.05 72.28 18.11 77.48 18.11 77.48 18.99 71.19 18.99",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,19.2a2.42,2.42,0,0,0,1.36-.31,1.08,1.08,0,0,0,.44-1V17.1a1.17,1.17,0,0,0-.29-.87,1.24,1.24,0,0,0-.82-.4,1.3,1.3,0,0,0,.82-.33,1,1,0,0,0,.27-.78V14a1.18,1.18,0,0,0-.34-1,1.48,1.48,0,0,0-1-.31H62.15V19.2Zm0-.89a.73.73,0,0,0,.56-.17.85.85,0,0,0,.15-.6V17a.88.88,0,0,0-.15-.62.77.77,0,0,0-.56-.16H63.24v2.08Zm-3.74-2.94V13.59H67a.73.73,0,0,1,.51.12.56.56,0,0,1,.16.44v.64a.66.66,0,0,1-.16.47,1,1,0,0,1-.51.11Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.68,19.2a5.78,5.78,0,0,0,1.37-.13,2.52,2.52,0,0,0,1-.38,2.56,2.56,0,0,0,1-1.15,3.54,3.54,0,0,0,.35-1.62,3.69,3.69,0,0,0-.35-1.57,2.69,2.69,0,0,0-1-1.13,2.52,2.52,0,0,0-1-.38,7.23,7.23,0,0,0-1.37-.13H52V19.2h3.68m0-.91H53.09v-4.7h2.59a3.35,3.35,0,0,1,2,.56,2.15,2.15,0,0,1,.67,1.77,2.25,2.25,0,0,1-.67,1.82,3.1,3.1,0,0,1-2,.55",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.54,15.83V13.55h3.7a.67.67,0,0,1,.53.15.69.69,0,0,1,.15.51v1a.74.74,0,0,1-.13.51.76.76,0,0,1-.55.15Zm4.52,3.37h1.59l-2.94-2.53h.95a1.48,1.48,0,0,0,1-.31,1.22,1.22,0,0,0,.33-.95V14a1.22,1.22,0,0,0-.33-1,1.48,1.48,0,0,0-1-.31H42.45V19.2h1.09V16.67h1.88Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.33,17.61l.84,1.59h1.17l-3.59-6.49H35.6L32.06,19.2h1.06l.82-1.59Zm-3.92-.82,1.72-3.33h0l1.72,3.33Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.19,17.6,30,19.2h1.17l-3.59-6.49H26.47L22.92,19.2H24l.82-1.6Zm-3.92-.82L27,13.46h0l1.73,3.32Z",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.97 18.99 12.97 12.5 14.06 12.5 14.06 15.16 19.15 15.16 19.15 12.5 20.24 12.5 20.24 18.99 19.15 18.99 19.15 16.05 14.06 16.05 14.06 18.99 12.97 18.99",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.38,38.79c11.48-1.26,22.29-3.08,32.56-8.57,2.63-2,4.61-3.17,6.18-6,3.81-6.82-1.77-11.7-6.63-15.29,6.27,1.51,13.19,6.14,12.92,13.34-.51,14.05-36.17,16-45,16.49",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6.21C34.52,1.43,13.2,3.49,6.88,14.75,3.07,21.57,8.68,26.45,13.51,30,7.26,28.53.34,23.88.59,16.7,1.1,2.65,36.78.7,45.6.21",
    transform: "translate(-0.58 -0.21)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo2.a16647c76dabd6506290496a27eaeea8.svg";